import React from 'react'

import { Check } from 'lucide-react'

import { Badge } from '@/shared/components/atoms/Badge/Badge'

interface SelectableBadgeProps {
	tag: string
	isSelected: boolean
	onClick: () => void
	className?: string
	disabled?: boolean
}

const SelectableBadge: React.FC<SelectableBadgeProps> = ({
	tag,
	isSelected,
	onClick,
	className = '',
	disabled = false,
}) => {
	return (
		<Badge
			variant="secondary"
			className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} py-2 px-3 w-fit flex items-center gap-2 ${isSelected ? 'bg-foreground text-background hover:bg-foreground/80 hover:text-background' : 'bg-shade text-content-tertiary hover:bg-shade/80 hover:text-content-tertiary'} ${className}`}
			onClick={disabled ? undefined : onClick}
		>
			{isSelected && (
				<div className="w-4 h-4 rounded-full bg-background flex items-center justify-center">
					<Check className="w-3 h-3 text-foreground" />
				</div>
			)}
			{tag}
		</Badge>
	)
}

export default SelectableBadge
